import { useState } from 'react';
import Item from '../item';
import { ItemName } from '../item/item-types';
import { getFoodFromIngredients } from '../item/item-utils';
import Filter from '../menu/filter';
import { PageSubTitle } from '../menu/page-sub-title';
import './ingredients-table.css';

const items = [
    ItemName.Grilling_Skewer,
    ItemName.Redwood_Roast,
    ItemName.Spiny_Chestnut,
    ItemName.Cherry_Bomb,
    ItemName.Stone_Steak,
    ItemName.Vampiric_Wine,
    ItemName.Silverscale_Fish,
    ItemName.Clearspring_Watermelon,
    ItemName.Sour_Lemon,
    ItemName.Poisonous_Mushroom,
    ItemName.Seasonal_Pumpkin,
    // ItemName.Hardboiled_Egg,
    ItemName.Honeycomb,
];

const IngredientsTable: React.FC = () => {
    const [filteredItems, setFilteredItems] = useState<ItemName[]>(items);

    return (<div className='ingredients-table' id="ingredientsTable">
        <PageSubTitle
            label='Ingredients Table'
            name='ingredients-table'
            image='/resources/cauldron/ingredients_table_icon.png'
        />

        <div className='ingredients-table-filter-container'>
            <Filter items={items} setFilteredItems={setFilteredItems} />
        </div >

        <table>
            <thead>
                <tr>
                    <th></th>
                    {filteredItems.map(itemName => (
                        <th key={itemName}><Item itemName={itemName} /></th>
                    ))}
                </tr>
            </thead>
            <tbody>
                {filteredItems.slice().reverse().map((rowName, rowIdx) => (
                    <tr key={rowName}>
                        <th><Item itemName={rowName} /></th>
                        {filteredItems.map((colName, colIdx) => {
                            if (colIdx >= filteredItems.length - rowIdx) {
                                return <td key={colName}></td>;
                            }
                            const resultItemName = getFoodFromIngredients(rowName, colName);
                            return (
                                <td key={colName}>
                                    {resultItemName ? <Item itemName={resultItemName} /> :
                                        filteredItems.length === 1 ? <img src='/resources/meme/tuh-cat.gif' alt='tuh' /> : null}
                                </td>
                            );
                        })}
                    </tr>
                ))}
            </tbody>
        </table>
    </div>
    );
};

export default IngredientsTable;